module.exports = "https://static.energy5.com/_next/static/images/faqService-514fed9f4e21f8027fbdde28d014cc4b.webp";